import React from 'react';

const Tick = () => (
  <svg
    width="12"
    height="10"
    viewBox="0 0 12 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.1611 0.314094L3.84698 6.62819L1.82819 4.6094C1.4094 4.1906 0.732886 4.1906 0.314094 4.6094C-0.104698 5.02819 -0.104698 5.7047 0.314094 6.12349L3.0953 8.9047C3.51409 9.32349 4.1906 9.32349 4.6094 8.9047L11.6859 1.82819C12.1047 1.4094 12.1047 0.732886 11.6859 0.314094C11.2671 -0.104698 10.5799 -0.104698 10.1611 0.314094Z"
      fill="#00A331"
    />
  </svg>
);

export default Tick;
